import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { CTA_EVENT_NAME } from '../../../constants';
import { handleMktAnalytics } from '../../../AmexUtils';
import './LayoutMenuItem.scss';

const LayoutMenuItem = ({
  awsFolderName,
  baseRequestUrl,
  iconLink,
  itemConfig: {
    title,
    copy,
    image,
    cta: {
      label_desktop: labelDesktop,
      label_mobile: labelMobile,
      label_symbol: labelSymbol,
      aria,
      url,
    },
  },
  Analytics,
  tabHeading: heading,
  matchMedia,
}) => {
  const sanitizedTitle = sanitizeString(title);
  const sanitizedCopy = sanitizeString(copy);
  const urlPrefix = `${baseRequestUrl}${awsFolderName}/carouselImages/`;
  const imageSrc = `${urlPrefix}tabContentImages/${image}`;
  const pdfSource = `${baseRequestUrl}${awsFolderName}/pdfs/${url}`;
  const externalLink = `${urlPrefix}tabContentImages/${iconLink}`;
  const label = matchMedia.lg ? labelDesktop : labelMobile;
  const sanitizedLabel = sanitizeString(label);

  const specificParam = {
    item_name: title,
    action_name: 'Menu Click',
    tab_item: heading,
  };
  const renderMenuItem = () => (
    <Link
      className="LayoutMenuItem"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={copy}
      href={pdfSource}
      onClick={() => handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, specificParam)}
    >
      <h3
        className="LayoutMenuItem__title"
        dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
          __html: sanitizedTitle,
        }}
      />
      <div
        className="LayoutMenuItem__image"
        style={{
          backgroundImage: `url(${imageSrc})`,
        }}
      />
      <p className="LayoutMenuItem__cta">
        <span
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedLabel,
          }}
        />
        {externalLink && (
          <img
            src={externalLink}
            alt={aria}
            className="LayoutMenuItem__external-icon"
          />
        )}
        {labelSymbol && (
          <span
            className="LayoutMenuItem__label-symbol"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: labelSymbol,
            }}
          />
        )}
      </p>
      <div className="LayoutMenuItem__copy-wrapper">
        <p
          className="LayoutMenuItem__copy"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedCopy,
          }}
        />
      </div>
    </Link>
  );
  return renderMenuItem();
};
LayoutMenuItem.propTypes = {
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  iconLink: PropTypes.string.isRequired,
  itemConfig: PropTypes.shape({
    title: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      action_name: PropTypes.string.isRequired,
    }),
  }).isRequired,
  tabHeading: PropTypes.string.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
};

export default LayoutMenuItem;
